import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  width: 100%;
  background-color: #f5f5f7;
  box-sizing: border-box;

  @media only screen and (min-width: 900px) {
    padding: 80px 120px;
  }
`;

export const Title = styled.h4`
  margin: 0 0 10px 0;
  color: #595959;
  font-weight: 700;
  padding: 0;
`;

export const P = styled.p`
  color: #86868b;
  margin: 0 0 10px 0;
  padding: 0;
`;




// WEBPACK FOOTER //
// ./src/containers/Simulator/Footer/styles.js